/**
 * Useful for when scrolling multiple scroll bars at the same time.
 *  
 * We can't use scrollIntoView since it can't handle multiple
 * scrolls (chrome bug) in different components at the same time.
 */
 export default function (scrollBar, scrollToEl, axis = 'all', behavior = 'smooth') {
  const top = scrollToEl.getBoundingClientRect().top - scrollBar.getBoundingClientRect().top + scrollBar.scrollTop;
  const offsetLeft = scrollToEl.offsetLeft;
  
  const center = scrollBar.scrollLeft + scrollBar.clientWidth / 2;
  
  const distFromCenter = offsetLeft - center;
  const left = scrollBar.scrollLeft + distFromCenter + scrollToEl.clientWidth/2;

  const options = {
    behavior
  };

  if (axis === 'x' || axis === 'all') {
    options.left = left;
  }
  if (axis === 'y' || axis === 'all') {
    options.top = top;
  }

  scrollBar.scrollTo(options);
}